import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import React from "react";
import "../../cssfiles/homepage.css";
import CustomButton from '../CommonComponents/CustomButton';
import CustomActionButton from '../CommonComponents/CustomActionButton';
import CustomTableHeading from '../CommonComponents/CustomTableHeading';
import CustomTableMetric from '../CommonComponents/CustomTableMetric';
import CustomLabel from '../CommonComponents/CustomLabel';
import CustomTextField from '../CommonComponents/CustomTextField';
import {Box,Menu, MenuItem,Button} from '@mui/material';
import CustomCancelButton from "../CommonComponents/CustomCancelButton";

const CustomSubheading = ({ children }) => {
    return (
        <Typography className="config-compliance-subheading" style={{ fontSize: '18px', fontWeight: 400, color: 'var(--SecondaryText)' }}>
            {children}
        </Typography>
    );
};

// const CustomTableTextField = ({ id, defaultValue }) => {
//     return (
//         <TextField
//             id={id}
//             defaultValue={defaultValue}
//             variant="standard"
//             sx={{
//                 width: '94px',
//                 '& .MuiInputBase-root': {
//                     fontFamily: 'Roboto',
//                     fontSize: '14px',
//                     fontWeight: '400',
//                     color: 'var(--SecondaryText)'
//                 },
//                 '& .MuiInput-root .MuiInputBase-input': {
//                     padding: 0,
//                 },
//                 '& .MuiInputBase-root::before': {
//                     borderBottom: '0px solid var(--PrimaryBackground)',
//                 },
//                 '& .MuiInputBase-root::after': {
//                     borderBottom: '0px solid var(--PrimaryBackground)',  //--PrimaryText
//                 },
//             }}
//         />
//     );
// }

export default function ComplianceConfiguration() {
    return (
        <Box className="compliance-config" sx={{height :"100%",boxSizing:"border-box" }}>
        <Box  sx={{padding:"0px",height:'calc(100% - 0px)',width:"100%" ,boxSizing:"border-box"}} >
            <Box  sx={{padding:"0px",width:'100%',height:"7%" ,boxSizing:"border-box",display:"flex",gap:'8px'}} >
                <Box sx={{flexGrow:1}}></Box>
                <CustomCancelButton onClick={''} buttonText={'Cancel'}></CustomCancelButton>
                {/* <Button id={props.index} onClick={props.saveForm}>Save</Button> */}
               
                <CustomButton /*id={assetInfo.id}*/ onClick={''} buttonText={'Save'} width={'12px'} />
            </Box>
            <Box sx={{boxSizing:"border-box",padding:"8px",background:'var(--PrimaryBackground)',height:'calc(93%)',marginBottom:"0px",overflow:"auto"}}>
                <Box className="config-form-box" sx={{padding:"4px 4px 4px 0px",width:"100%",boxSizing:'border-box',marginTop:"12px"}}>
                <form action='' method='' >
                <div style={{ display: "inline-block", width: '100%', paddingBottom: '40px' }}>
                    <table align='left' style={{ margin: 0, padding: 0, borderSpacing: 0 }}>
                        <tr>
                            <td colSpan={12}>
                                <CustomSubheading children={'Human Rights Issues (no. of issues)'} />
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <CustomLabel htmlFor={'resolved-issues'} children={'Resolved Issues'} />
                            </td>
                            <td style={{ paddingRight: '25px' }}>
                                <CustomTextField id={'resolved-issues'} defaultValue={0} />
                            </td>
                            <td>
                                <CustomLabel htmlFor={'pending-issues'} children={'Pending Issues'} />
                            </td>
                            <td style={{ paddingRight: '25px' }}>
                                <CustomTextField id={'pending-issues'} defaultValue={0} />
                            </td>
                        </tr>

                        <tr>
                            <td colSpan={12} style={{ paddingTop: '40px' }}>
                                <CustomSubheading children={'Customer Relations (Feedback)'} />
                            </td>
                        </tr>
                        <tr>
                            <td style={{ paddingRight: '10px' }}>
                                <CustomLabel htmlFor={'positive-feedback'} children={'Positive Feedback'} />
                            </td>
                            <td style={{ paddingRight: '25px' }}>
                                <CustomTextField id={'positive-feedback'} defaultValue={0} />
                            </td>
                            <td style={{ paddingRight: '10px' }}>
                                <CustomLabel htmlFor={'negative-feedback'} children={'Negative Feedback'} />
                            </td>
                            <td style={{ paddingRight: '25px' }}>
                                <CustomTextField id={'negative-feedback'} defaultValue={0} />
                            </td>
                        </tr>

                        <tr>
                            <td colSpan={12} style={{ paddingTop: '40px' }}>
                                <CustomSubheading children={'Air Pollutants (μg/m\u00b3)'} />
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <CustomLabel htmlFor={'co'} children={'CO'} />
                            </td>
                            <td style={{ paddingRight: '25px' }}>
                                <CustomTextField id={'co'} defaultValue={0.0} />
                            </td>
                            <td>
                                <CustomLabel htmlFor={'no2'} children={'NO\u2082'} />
                            </td>
                            <td style={{ paddingRight: '25px' }}>
                                <CustomTextField id={'no2'} defaultValue={0.0} />
                            </td>
                            <td style={{ paddingRight: '115px' }}>
                                <CustomLabel htmlFor={'so2'} children={'SO\u2082'} />
                            </td>
                            <td style={{ paddingRight: '25px' }}>
                                <CustomTextField id={'so2'} defaultValue={0.0} />
                            </td>
                            <td style={{ paddingRight: '115px' }}>
                                <CustomLabel htmlFor={'o3'} children={'O\u2083'} />
                            </td>
                            <td style={{ paddingRight: '25px' }}>
                                <CustomTextField id={'o3'} defaultValue={0.0} />
                            </td>
                            <td style={{ paddingRight: '115px' }}>
                                <CustomLabel htmlFor={'pm10'} children={'PM\u2081\u2080'} />
                            </td>
                            <td style={{ paddingRight: '25px' }}>
                                <CustomTextField id={'pm10'} defaultValue={0.0} />
                            </td>
                            <td style={{ paddingRight: '115px' }}>
                                <CustomLabel htmlFor={'pm2.5'} children={'PM\u2082\u002E\u2085'} />
                            </td>
                            <td style={{ paddingRight: '25px' }}>
                                <CustomTextField id={'pm2.5'} defaultValue={0.0} />
                            </td>
                        </tr>

                        <tr>
                            <td colSpan={12} style={{ paddingTop: '40px' }}>
                                <CustomSubheading children={'Board Diversity (no. of people)'} />
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <CustomLabel htmlFor={'female-board-div'} children={'Female'} />
                            </td>
                            <td style={{ paddingRight: '25px' }}>
                                <CustomTextField id={'female-board-div'} defaultValue={0} />
                            </td>
                            <td>
                                <CustomLabel htmlFor={'male-board-div'} children={'Male'} />
                            </td>
                            <td style={{ paddingRight: '25px' }}>
                                <CustomTextField id={'male-board-div'} defaultValue={0} />
                            </td>
                        </tr>

                        <tr>
                            <td colSpan={2} style={{ paddingTop: '40px' }}>
                                <CustomSubheading children={'Discrimination (no. of cases)'} />
                            </td>
                            <td colSpan={2} style={{ paddingTop: '40px' }}>
                                <CustomSubheading children={'Bribery (no. of cases)'} />
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <CustomLabel htmlFor={'discrimination'} children={'Discrimination'} />
                            </td>
                            <td style={{ paddingRight: '25px' }}>
                                <CustomTextField id={'discrimination'} defaultValue={0} />
                            </td>
                            <td>
                                <CustomLabel htmlFor={'bribery'} children={'Bribery'} />
                            </td>
                            <td style={{ paddingRight: '25px' }}>
                                <CustomTextField id={'bribery'} defaultValue={0} />
                            </td>
                        </tr>

                        <tr>
                            <td colSpan={12} style={{ paddingTop: '40px' }}>
                                <CustomSubheading children={'Employee Diversity (no. of people)'} />
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <CustomLabel htmlFor={'female-emp-div'} children={'Female'} />
                            </td>
                            <td style={{ paddingRight: '25px' }}>
                                <CustomTextField id={'female-emp-div'} defaultValue={0} />
                            </td>
                            <td>
                                <CustomLabel htmlFor={'male-emp-div'} children={'Male'} />
                            </td>
                            <td style={{ paddingRight: '25px' }}>
                                <CustomTextField id={'male-emp-div'} defaultValue={0} />
                            </td>
                        </tr>

                        <tr>
                            <td colSpan={12} style={{ paddingTop: '40px' }}>
                                <CustomSubheading children={'Employee Relations (no. of cases)'} />
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <CustomLabel htmlFor={'internal-disputes'} children={'Internal Disputes'} />
                            </td>
                            <td style={{ paddingRight: '25px' }}>
                                <CustomTextField id={'internal-disputes'} defaultValue={0} />
                            </td>
                            <td>
                                <CustomLabel htmlFor={'harassment'} children={'Harassment'} />
                            </td>
                            <td style={{ paddingRight: '25px' }}>
                                <CustomTextField id={'harassment'} defaultValue={0} />
                            </td>
                        </tr>

                        {/* <tr>
                            <td colSpan={12} style={{ paddingTop: '40px' }}>
                                <CustomSubheading children={'Community Engagement'} />
                            </td>
                        </tr> */}
                        {/* <tr>
                            <td colSpan={1}>
                                <CustomLabel htmlFor={'beneficiaries'} children={'Number of Beneficiaries'} />
                            </td>
                            <td style={{ paddingRight: '25px' }}>
                                <CustomTextField id={'beneficiaries'} defaultValue={0} />
                            </td>
                            <td colSpan={2}>
                                <CustomLabel htmlFor={'amt-spent'} children={'Amount spent on community welfare activities'} />
                            </td>
                            <td style={{ paddingRight: '25px' }}>
                                <CustomTextField id={'amt-spent'} defaultValue={0} />
                            </td>
                        </tr> */}
                    </table>
                </div>

                <div style={{ display: "inline-block", width: '100%', paddingBottom: '40px' }}>
                    <table align='left' style={{ margin: 0, padding: 0, borderSpacing: 0 }}>
                        <tr>
                            <td colSpan={4}>
                                <CustomSubheading children={'Community Engagement'} />
                            </td>
                        </tr>
                        <tr>
                            <td style={{ paddingRight: '20px' }}>
                                <CustomLabel htmlFor={'beneficiaries'} children={'Number of Beneficiaries'} />
                            </td>
                            <td style={{ paddingRight: '25px' }}>
                                <CustomTextField id={'beneficiaries'} defaultValue={0} />
                            </td>
                            <td style={{ paddingRight: '20px' }}>
                                <CustomLabel htmlFor={'amt-spent'} children={'Amount spent on community welfare activities'} />
                            </td>
                            <td style={{ paddingRight: '25px' }}>
                                <CustomTextField id={'amt-spent'} defaultValue={0} />
                            </td>
                        </tr>
                    </table>
                </div>

                <CustomSubheading children={'Scope 1'} />
                <div style={{ display: "inline-block", width: '100%', paddingBottom: '40px' }}>
                    <table align='left' className='scope1-config-table' style={{ margin: 0, padding: '0', borderSpacing: 0, borderCollapse: 'collapse' }}>
                        <tr className='scope1-config-table-heading'>
                            <td>
                                <CustomTableHeading children={'Metric'} />
                            </td>
                            <td>
                                <CustomTableHeading children={'Quantity'} />
                            </td>
                            <td>
                                <CustomTableHeading children={'CO\u2082(Tonnes)'} />
                            </td>
                            <td style={{ paddingRight: '25px' }}>
                                <CustomTableHeading children={'GWP Factor'} />
                            </td>
                            <td>
                                <CustomTableHeading children={'CH\u2082(Tonnes)'} />
                            </td>
                            <td style={{ paddingRight: '25px' }}>
                                <CustomTableHeading children={'GWP Factor'} />
                            </td>
                            <td>
                                <CustomTableHeading children={'N\u2082O(Tonnes)'} />
                            </td>
                            <td>
                                <CustomTableHeading children={'GWP Factor'} />
                            </td>
                        </tr>

                        <tr>
                            <td style={{ paddingRight: '20px' }}>
                                <CustomTableMetric children={'Stationary Combustion of Fuel'} />
                            </td>
                            <td>
                                <CustomTextField id={'config-quantity-scope1-stationary'} defaultValue={0} />
                            </td>
                            <td>
                                <CustomTextField id={'config-co2-scope1-stationary'} defaultValue={0} />
                            </td>
                            <td>
                                <CustomTableMetric children={1} />
                            </td>
                            <td>
                                <CustomTextField id={'config-ch4-scope1-stationary'} defaultValue={0} />
                            </td>
                            <td>
                                <CustomTableMetric children={27.9} />
                            </td>
                            <td>
                                <CustomTextField id={'config-n2o-scope1-stationary'} defaultValue={0} />
                            </td>
                            <td>
                                <CustomTableMetric children={273} />
                            </td>
                        </tr>

                        <tr>
                            <td>
                                <CustomTableMetric children={'Mobile Combustion of Fuel'} />
                            </td>
                            <td>
                                <CustomTextField id={'config-quantity-scope1-mobile'} defaultValue={0} />
                            </td>
                            <td>
                                <CustomTextField id={'config-co2-scope1-mobile'} defaultValue={0} />
                            </td>
                            <td>
                                <CustomTableMetric children={1} />
                            </td>
                            <td>
                                <CustomTextField id={'config-ch4-scope1-mobile'} defaultValue={0} />
                            </td>
                            <td>
                                <CustomTableMetric children={27.9} />
                            </td>
                            <td>
                                <CustomTextField id={'config-n2o-scope1-mobile'} defaultValue={0} />
                            </td>
                            <td>
                                <CustomTableMetric children={273} />
                            </td>
                        </tr>

                        <tr>
                            <td>
                                <CustomTableMetric children={'Industrial Process'} />
                            </td>
                            <td>
                                <CustomTextField id={'config-quantity-scope1-ind-process'} defaultValue={0} />
                            </td>
                            <td>
                                <CustomTextField id={'config-co2-scope1-ind-process'} defaultValue={0} />
                            </td>
                            <td>
                                <CustomTableMetric children={1} />
                            </td>
                            <td>
                                <CustomTextField id={'config-ch4-scope1-ind-process'} defaultValue={0} />
                            </td>
                            <td>
                                <CustomTableMetric children={27.9} />
                            </td>
                            <td>
                                <CustomTextField id={'config-n2o-scope1-ind-process'} defaultValue={0} />
                            </td>
                            <td>
                                <CustomTableMetric children={273} />
                            </td>
                        </tr>

                        <tr>
                            <td>
                                <CustomTableMetric children={'Fugitive Emissions'} />
                            </td>
                            <td>
                                <CustomTextField id={'config-quantity-scope1-fug-em'} defaultValue={0} />
                            </td>
                            <td>
                                <CustomTextField id={'config-co2-scope1-fug-em'} defaultValue={0} />
                            </td>
                            <td>
                                <CustomTableMetric children={1} />
                            </td>
                            <td>
                                <CustomTextField id={'config-ch4-scope1-fug-em'} defaultValue={0} />
                            </td>
                            <td>
                                <CustomTableMetric children={27.9} />
                            </td>
                            <td>
                                <CustomTextField id={'config-n2o-scope1-fug-em'} defaultValue={0} />
                            </td>
                            <td>
                                <CustomTableMetric children={273} />
                            </td>
                        </tr>

                        <tr>
                            <td>
                                <CustomTableMetric children={'Land Use'} />
                            </td>
                            <td>
                                <CustomTextField id={'config-quantity-scope1-land-use'} defaultValue={0} />
                            </td>
                            <td>
                                <CustomTextField id={'config-co2-scope1-land-use'} defaultValue={0} />
                            </td>
                            <td>
                                <CustomTableMetric children={1} />
                            </td>
                            <td>
                                <CustomTextField id={'config-ch4-scope1-land-use'} defaultValue={0} />
                            </td>
                            <td>
                                <CustomTableMetric children={27.9} />
                            </td>
                            <td>
                                <CustomTextField id={'config-n2o-scope1-land-use'} defaultValue={0} />
                            </td>
                            <td>
                                <CustomTableMetric children={273} />
                            </td>
                        </tr>
                        <tr style={{ borderBottom: '0px solid var(--GreyBaseColor)' }}>
                            <td align="left" colSpan={8}>
                                <CustomActionButton children={"+ Add"} />
                            </td>
                        </tr>
                    </table>
                </div>

                <CustomSubheading children={'Scope 2'} />
                <div style={{ display: "inline-block", width: '100%', paddingBottom: '40px' }}>
                    <table align='left' style={{ margin: 0, padding: 0, borderSpacing: 0 }}>
                        <tr>
                            <td style={{ paddingRight: '20px' }}>
                                <CustomLabel htmlFor={'emission-factor-config'} children={'Emission Factor for Grid(/kWh)'} />
                            </td>
                            <td>
                                <Typography sx={{ fontSize: '16px', fontFamily: 'Roboto', fontWeight: 700, color: 'var(--PrimaryText)' }}>0.716</Typography>
                                {/* <CustomLabel htmlFor={'emission-factor-config'} children={'0.716'} /> */}
                            </td>
                        </tr>
                    </table>
                </div>

                <CustomSubheading children={'Scope 3'} />
                <div style={{ display: "inline-block", width: '100%' }}>
                    <table align='left' className='scope1-config-table' style={{ margin: 0, padding: '0', borderSpacing: 0, borderCollapse: 'collapse' }}>
                        <tr className='scope1-config-table-heading'>
                            <td>
                                <CustomTableHeading children={'Metric'} />
                            </td>
                            <td>
                                <CustomTableHeading children={'Quantity'} />
                            </td>
                            <td>
                                <CustomTableHeading children={'tCO\u2082e'} />
                            </td>
                        </tr>
                        <tr>
                            <td colSpan={3}>
                                <CustomTableHeading children={'Upstream'} />
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <CustomTableMetric children={'Purchased Goods and Services'} />
                            </td>
                            <td>
                                <CustomTextField id={'config-scope3-quantity-pur-goods'} defaultValue={0} />
                            </td>
                            <td>
                                <CustomTextField id={'config-scope3-tco2e-pur-goods'} defaultValue={0} />
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <CustomTableMetric children={'Capital Goods'} />
                            </td>
                            <td>
                                <CustomTextField id={'config-scope3-quantity-cap-goods'} defaultValue={0} />
                            </td>
                            <td>
                                <CustomTextField id={'config-scope3-tco2e-cap-goods'} defaultValue={0} />
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <CustomTableMetric children={'Fuel and Energy Related Activities'} />
                            </td>
                            <td>
                                <CustomTextField id={'config-scope3-quantity-fuel-energy'} defaultValue={0} />
                            </td>
                            <td>
                                <CustomTextField id={'config-scope3-tco2e-fuel-energy'} defaultValue={0} />
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <CustomTableMetric children={'Upstream Transportation and Distribution'} />
                            </td>
                            <td>
                                <CustomTextField id={'config-scope3-quantity-upstream-tnd'} defaultValue={0} />
                            </td>
                            <td>
                                <CustomTextField id={'config-scope3-tco2e-upstream-tnd'} defaultValue={0} />
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <CustomTableMetric children={'Waste Generated in Operations'} />
                            </td>
                            <td>
                                <CustomTextField id={'config-scope3-quantity-waste-gen-op'} defaultValue={0} />
                            </td>
                            <td>
                                <CustomTextField id={'config-scope3-tco2e-waste-gen-op'} defaultValue={0} />
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <CustomTableMetric children={'Business Travel'} />
                            </td>
                            <td>
                                <CustomTextField id={'config-scope3-quantity-business-travel'} defaultValue={0} />
                            </td>
                            <td>
                                <CustomTextField id={'config-scope3-tco2e-business-travel'} defaultValue={0} />
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <CustomTableMetric children={'Employee Commuting'} />
                            </td>
                            <td>
                                <CustomTextField id={'config-scope3-quantity-employee-comm'} defaultValue={0} />
                            </td>
                            <td>
                                <CustomTextField id={'config-scope3-tco2e-employee-comm'} defaultValue={0} />
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <CustomTableMetric children={'Upstream Leased Assets'} />
                            </td>
                            <td>
                                <CustomTextField id={'config-scope3-quantity-upstream-leased-assets'} defaultValue={0} />
                            </td>
                            <td>
                                <CustomTextField id={'config-scope3-tco2e-upstream-leased-assets'} defaultValue={0} />
                            </td>
                        </tr>
                        <tr>
                            <td align="left" colSpan={3}>
                                <CustomActionButton children={"+ Add"} />
                            </td>
                        </tr>
                        <tr>
                            <td colSpan={3}>
                                <CustomTableHeading children={'Downstream'} />
                            </td>
                        </tr>
                        <tr>
                            <td style={{ paddingRight: '20px' }}>
                                <CustomTableMetric children={'Downstream Transportation and Distribution'} />
                            </td>
                            <td>
                                <CustomTextField id={'config-scope3-quantity-downstream-tnd'} defaultValue={0} />
                            </td>
                            <td>
                                <CustomTextField id={'config-scope3-tco2e-downstream-tnd'} defaultValue={0} />
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <CustomTableMetric children={'Processing of Sold Products'} />
                            </td>
                            <td>
                                <CustomTextField id={'config-scope3-quantity-pro-sold-prod'} defaultValue={0} />
                            </td>
                            <td>
                                <CustomTextField id={'config-scope3-tco2e-pro-sold-prod'} defaultValue={0} />
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <CustomTableMetric children={'Use of Sold Products'} />
                            </td>
                            <td>
                                <CustomTextField id={'config-scope3-quantity-use-sold-prod'} defaultValue={0} />
                            </td>
                            <td>
                                <CustomTextField id={'config-scope3-tco2e-use-sold-prod'} defaultValue={0} />
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <CustomTableMetric children={'End-of-Life Treatment of Sold Products'} />
                            </td>
                            <td>
                                <CustomTextField id={'config-scope3-quantity-end-sold-prod'} defaultValue={0} />
                            </td>
                            <td>
                                <CustomTextField id={'config-scope3-tco2e-end-sold-prod'} defaultValue={0} />
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <CustomTableMetric children={'Downstream Leased Assets'} />
                            </td>
                            <td>
                                <CustomTextField id={'config-scope3-quantity-Downstream-leased-assets'} defaultValue={0} />
                            </td>
                            <td>
                                <CustomTextField id={'config-scope3-tco2e-Downstream-leased-assets'} defaultValue={0} />
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <CustomTableMetric children={'Franchises'} />
                            </td>
                            <td>
                                <CustomTextField id={'config-scope3-quantity-franchises'} defaultValue={0} />
                            </td>
                            <td>
                                <CustomTextField id={'config-scope3-tco2e-franchises'} defaultValue={0} />
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <CustomTableMetric children={'Investments'} />
                            </td>
                            <td>
                                <CustomTextField id={'config-scope3-quantity-investments'} defaultValue={0} />
                            </td>
                            <td>
                                <CustomTextField id={'config-scope3-tco2e-investments'} defaultValue={0} />
                            </td>
                        </tr>
                        <tr>
                            <td align="left" colSpan={3}>
                                <CustomActionButton buttonText={"+ Add"} />
                            </td>
                        </tr>
                        <tr style={{ borderBottom: '0px solid var(--GreyBaseColor)' }}>
                            <td colSpan={3} align='left' style={{ paddingBottom: 0 }}>
                                <CustomButton buttonText={'Save'} />
                            </td>
                        </tr>
                    </table>
                </div>
            </form>
                </Box>                    
            </Box>
        </Box>
    </Box>
    )
}

